'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTabs = require('react-tabs');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTabs2 = require('react-tabs/style/react-tabs.css');

var _reactTabs3 = _interopRequireDefault(_reactTabs2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WpTab = function (_Component) {
  _inherits(WpTab, _Component);

  function WpTab(props) {
    _classCallCheck(this, WpTab);

    var _this = _possibleConstructorReturn(this, (WpTab.__proto__ || Object.getPrototypeOf(WpTab)).call(this, props));

    var defaultTab = _this.props.defaultTab;

    _this.state = {
      activeTab: defaultTab || 0
    };

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  _createClass(WpTab, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactTabs.Tabs,
        {
          onSelect: this.handleSelect,
          selectedIndex: this.state.activeTab
        },
        _react2.default.createElement(
          _reactTabs.TabList,
          null,
          this.renderTabs()
        ),
        this.renderTabPanels()
      );
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      var tabs = this.props.tabs;

      return tabs.map(function (t) {
        return t.name;
      }).map(function (name) {
        return _react2.default.createElement(
          _reactTabs.Tab,
          { key: name },
          name
        );
      });
    }
  }, {
    key: 'renderTabPanels',
    value: function renderTabPanels() {
      var tabs = this.props.tabs;

      return tabs.map(function (t) {
        return t.panel;
      }).map(function (panel, key) {
        return _react2.default.createElement(
          _reactTabs.TabPanel,
          { key: key + '_panel' },
          panel
        );
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(index) {
      var tabs = this.props.tabs;

      var activeTab = index > tabs.length - 1 ? tabs.length - 1 : index;
      console.log('Tab', index, activeTab);
      this.setState.apply(this, _toConsumableArray(this.state).concat([{ activeTab: activeTab }]));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.onRef(undefined);
    }
  }]);

  return WpTab;
}(_react.Component);

exports.default = WpTab;


WpTab.propTypes = process.env.NODE_ENV !== "production" ? {
  tabs: _propTypes2.default.array.isRequired,
  onRef: _propTypes2.default.func.isRequired,
  defaultTab: _propTypes2.default.number
} : {};